import { readLocalStorageData } from '@app/services/localStorage.service';
import { EMPTY_GUID } from '@app/shared/constants/globalConstans';
import { LocalStorageItems } from '@app/shared/constants/localStorageItems';
import {
	isABalanceAccountForAccountsItem,
	isABalanceAccountForAccountsItemAdapter,
	IWalletItem,
	WalletItemAdapter,
} from '@interfaces/FW/Wallets';

export const getWalletAdapter = (data: WalletItemAdapter[]): IWalletItem[] => {
	const client = readLocalStorageData(LocalStorageItems.client);
	const getInteractionType = (item: WalletItemAdapter) => {
		return item.ЯвляетьсяСчетомБалансаДляСчетов.length > 0
			? 0
			: client.cooperationScheme === 0 && item.СчетБаланса !== EMPTY_GUID
				? 1
				: 2;
	};

	const isABalanceAccountForAccountsAdapter = (
		data: isABalanceAccountForAccountsItemAdapter[],
	): isABalanceAccountForAccountsItem[] => {
		return data.map((item) => {
			return {
				walletGUID: item.Счет,
				walletName: item.СчетНаименование,
				walletCode: item.СчетКод,
				permissionView: item.ПравоПросмотр,
				permissionChange: item.ПравоИзменение,
			};
		});
	};

	const result: IWalletItem[] = data.map((item: WalletItemAdapter) => {
		return {
			isABalanceAccountForAccounts: isABalanceAccountForAccountsAdapter(
				item.ЯвляетьсяСчетомБалансаДляСчетов,
			),
			walletBalanceLawChanges: item.СчетБалансаПравоИзменения,
			walletId: item.ИдСчета,
			walletIndividualBalance: item.СчетИндивидуальныйБаланс,
			walletBalanceRightView: item.СчетБалансаПравоПросмотра,
			walletBalance: item.СчетБаланса,
			invoiceWithdrawInvoice: item.СчетВыводитьВСчетФактуру,
			walletTypeName: item.СчетВидНаименование,
			walletType: item.СчетВид,
			contractorID: item.ИдКонтрагента,
			whenMovingMapsAllowUseMobileApp:
				item.ПриПеремещенииКартыРазрешитьИспользованиеМобильномПриложении,
			balanceWalletName: item.СчетБалансаНаименование,
			sendingEmail: item.ОтправкаEmail,
			walletOverdraft: item.СчетОвердрафт,
			walletState: item.СчетСостояние,
			walletAgreementName: item.СчетДоговорНаименование,
			walletAgreement: item.СчетДоговор,
			allowedChange: item.РазрешеноИзменение,
			walletCounterparty: item.СчетКонтрагент,
			sendingSMS: item.ОтправкаСМС,
			walletName: item.СчетНаименование,
			walletCounterpartyName: item.СчетКонтрагентНаименование,
			walletCode: item.СчетКод,
			walletGUID: item.Счет,
			interactionType: getInteractionType(item),
			hideAdditionalCheckInfo: item.ЗапретВыводаДопИнформацииВЧек,
			hasLimits: item.ЕстьЛимит,
			cardsAmount: item.КоличествоКарт,
			comment: item.Примечание,
		};
	});

	return result;
};
